<div class="flex flex-row bg-white py-2 p-2 justify-center text-lg" *ngIf="editMode">
  <div class="flex items-center justify-center">
    <span class="text-primary py-2"> {{ projectName }} - {{ projectId }} </span>
  </div>
</div>
<mat-horizontal-stepper [linear]="!editMode" #stepper>
  <mat-step projectForm [stepControl]="projectForm">
    <form [formGroup]="projectForm" class="p-6 bg-white rounded-lg shadow-md">
      <ng-template matStepLabel>{{
        projectId ? ("UPDATE_PROJECT" | translate) : ("ADD_PROJECT" | translate)
        }}</ng-template>

      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_name" readonly />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label> {{ "companyCode" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>

        <div class="col-span-6" *ngIf="branchShow">
          <mat-label> {{ "BRANCH" | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="branch_id" (selectionChange)="onBranchChange($event.value)">
              <mat-option value="">{{
                "SELECT_BRANCH" | translate
                }}</mat-option>
              <mat-option *ngFor="let branch of branchList" [value]="branch.branch_id">{{ branch.branch_name
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-span-6" *ngIf="!editMode">
          <mat-label> {{ "PROJECT_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="project_name" />
          </mat-form-field>
        </div>



        <div class="col-span-6">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="domain" (selectionChange)="onDomainChange($event.value)">
              <mat-option *ngFor="let domain of domainOptions" [value]="domain">
                {{ domain }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Sub Domain Dropdown -->
        <div class="col-span-6" *ngIf="getSubDomains().length > 0">
          <mat-label>{{ "SUB DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="sub_domain" (selectionChange)="onSubDomainChange()">
              <mat-option value="">{{ "SELECT SUB DOMAIN" | translate }}</mat-option>
              <mat-option *ngFor="let subDomain of getSubDomains()" [value]="subDomain">
                {{ subDomain | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Road Services Checklist (only for Road domain) -->
        <div class="col-span-12" *ngIf="showRoadServices()">
          <mat-label class="block mb-2 font-semibold">{{ "ROAD SERVICES" | translate }}</mat-label>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4 border rounded-lg bg-gray-50">
            <div *ngFor="let service of getRoadServices()" class="flex items-center">
              <mat-checkbox 
                [value]="service"
                (change)="onServiceChange($event, service)"
                [checked]="isServiceSelected(service)">
                {{ service }}
              </mat-checkbox>
            </div>
          </div>
        </div>

        <!-- Legacy sub-domain fields (keeping for backward compatibility) -->
        <div *ngIf="projectForm.value.domain=='Commercial'" class="col-span-6">
          <mat-label>{{ "Sub Domain" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="infrastructure_type" required>
              <mat-option value="Education">Education</mat-option>
              <mat-option value="Residential">Residential</mat-option>
              <mat-option value="Road">Road</mat-option>

            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="projectForm.value.domain=='Utilities'" class="col-span-6">
          <mat-label>{{ "Sub Domain" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="infrastructure_type" required>

              <mat-option value="Electric">Electric</mat-option>
              <mat-option value="Gas">Gas</mat-option>
              <mat-option value="Telecom">Telecom</mat-option>
              <mat-option value="Water">Water</mat-option>

            </mat-select>
          </mat-form-field>
        </div>
          <ng-container *ngIf="domainFields[selectedDomain]">
          <ng-container *ngFor="let field of domainFields[selectedDomain]">
            <!-- Date fields -->
            <div class="col-span-6" *ngIf="field.type === 'date' && projectForm.get(field.key)">
              <mat-label>{{ field.label | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="picker" [formControlName]="field.key" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Text fields -->
            <div class="col-span-6" *ngIf="field.type === 'text' && projectForm.get(field.key)">
              <mat-label>{{ field.label | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput [formControlName]="field.key" />
              </mat-form-field>
            </div>

            <!-- Numeric fields with unit conversion -->
            <div class="col-span-6" *ngIf="(field.type === 'number' || field.type === 'volume' || field.type === 'weight' || field.type === 'distance' || field.type === 'area' || field.type === 'size' || field.type === 'duration' || field.type === 'percentage') && projectForm.get(field.key)">
              <div class="flex gap-2 items-end">
                <div class="flex-1">
                  <mat-label>{{ field.label | translate }}</mat-label>
                  <mat-form-field appearance="outline" class="w-full">
                    <input matInput [type]="field.type === 'percentage' ? 'number' : 'number'" 
                           [formControlName]="field.key" 
                           [step]="field.type === 'percentage' ? '0.01' : '0.01'"
                           [min]="0" />
                    <span matSuffix *ngIf="field.type === 'percentage'">%</span>
                  </mat-form-field>
                </div>
                <!-- Unit selector for convertible fields -->
                <div class="w-32" *ngIf="field.type !== 'number' && field.type !== 'percentage'">
                  <mat-label>Unit</mat-label>
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-select [value]="getFieldUnit(field.key)" 
                                (selectionChange)="onFieldUnitChange(field.key, field.type, $event.value)">
                      <mat-option *ngFor="let unit of getAvailableUnitsForField(field.type)" [value]="unit.code">
                        {{ unit.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        





        <!-- Size, Unit, and FSI in a row (hidden for Road and Utilities domain) -->
        <div class="col-span-8" *ngIf="showSizeAndFsiFields()">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4">
              <mat-label>{{ "Size" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input matInput type="number" formControlName="size" [step]="0.01" [min]="0" />
              </mat-form-field>
            </div>
            <div class="col-span-4">
              <mat-label>{{ "Unit" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <mat-select [value]="getFieldUnit('size')" 
                            (selectionChange)="onSizeUnitChange($event.value)">
                  <mat-option *ngFor="let unit of getAvailableUnitsForField('size')" [value]="unit.code">
                    {{ unit.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-span-4">
              <mat-label>{{ "FSI (Floor Space Index)" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <mat-select formControlName="fsi" [compareWith]="compareFsi">
                  <mat-option *ngFor="let fsi of fsiOptions" [value]="fsi">
                    {{ fsi }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        
   

        <!-- Display Size in SQM (readonly) - hidden for Road and Utilities domain -->
        <div class="col-span-4" *ngIf="showSizeAndFsiFields() && getSizeInSqm() !== null">
          <mat-label>{{ "Construction Area Size (in SQM)" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [value]="getSizeInSqm() | number:'1.2-4'" readonly />
            <span matSuffix class="text-gray-500">(sqm*fsi)</span>
          </mat-form-field>
        </div>
       
        <div *ngIf="false" class="col-span-6">
          <mat-label>{{ "START_DATE_" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="startPicker" formControlName="start_date" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div *ngIf="false" class="col-span-6">
          <mat-label>{{ "END_DATE_" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="endPicker" formControlName="end_date" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Budget" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="budget_amount" />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Funding_Source" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="funding_source" />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Scope_Description" | translate }} to be linked with BOM</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="scope_description" />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Timeline_Start" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="timelinestart" formControlName="timeline_start" />
            <mat-datepicker-toggle matSuffix [for]="timelinestart"></mat-datepicker-toggle>
            <mat-datepicker #timelinestart></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Timeline_End" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="timelineend" formControlName="timeline_end" />
            <mat-datepicker-toggle matSuffix [for]="timelineend"></mat-datepicker-toggle>
            <mat-datepicker #timelineend></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Permit_Status" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="permit_status">
              <mat-option *ngFor="let status of permitStatusOptions" [value]="status">{{ status }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>Select Stage</mat-label>

          <mat-form-field appearance="outline">
            <mat-select formControlName="stage">
              <mat-option *ngFor="let stage of stages" [value]="stage.name">
                {{ stage.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="stageApprovals[selectedDoc]">
          <ng-container *ngFor="let field of stageApprovals[selectedDoc]; let i = index">
            <div class="col-span-4">
              <label class="block text-sm font-medium mb-1 text-gray-700">
                {{ field.label | translate }}
              </label>

              <div class="flex items-center space-x-4">
                <button mat-flat-button color="primary" (click)="triggerFileInput(i)">
                  <mat-icon>upload</mat-icon>
                  Upload File
                </button>

                <span class="text-sm text-gray-600 truncate w-60" *ngIf="projectForm.get(field.key)?.value?.name">
                  {{ projectForm.get(field.key)?.value?.name }}
                </span>
              </div>

              <input type="file" class="hidden" (change)="onFileChange($event, field.key)" #fileInputRef />
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="domainSanctionFields[selectedDom]">
          <ng-container *ngFor="
              let field of domainSanctionFields[selectedDom];
              let i = index
            ">
            <div class="col-span-4">
              <label class="block text-sm font-medium mb-1 text-gray-700">
                {{ field.label | translate }}
              </label>

              <div class="flex items-center space-x-4">
                <button mat-flat-button color="primary" (click)="triggerFileInput(i)">
                  <mat-icon>upload</mat-icon>
                  Upload File
                </button>

                <span class="text-sm text-gray-600 truncate w-60" *ngIf="projectForm.get(field.key)?.value?.name">
                  {{ projectForm.get(field.key)?.value?.name }}
                </span>
              </div>

              <input type="file" class="hidden" (change)="onFileChange($event, field.key)" #fileInputRef />
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="col-span-2 flex justify-end mt-4">
        <app-primary-button (click)="stepper.next()" matStepperNext>
          <div class="gap-2 flex items-center">
            {{ "LOCATION" | translate }}
          </div>
        </app-primary-button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="locationForm">
    <form [formGroup]="locationForm" class="w-full">
      <ng-template matStepLabel>{{ "LOCATION" | translate }}</ng-template>

      <div formArrayName="location">
        <div *ngFor="let branch of location.controls; let i = index" [formGroupName]="i">
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "COUNTRY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="country" (selectionChange)="onCountryBChange(i)" required>
                  <mat-option value="">{{
                    "SELECT_COUNTRY" | translate
                    }}</mat-option>
                  <mat-option value="India">India</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ "COUNTRY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="state" (selectionChange)="onStateBChange(i)" required>
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let state of availableStates[i]" [value]="state">
                    {{ state }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let city of availableCities[i]" [value]="city">
                    {{ city }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput placeholder="Pincode" formControlName="pincode" />
                <mat-error *ngIf="branch.get('pincode')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-span-6">
            <mat-label>{{ "Khasra_no" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="khasra_no" />
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>{{ "Area" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="area" />
            </mat-form-field>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error *ngIf="branch.get('address_line_1')?.hasError('required')">
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error *ngIf="branch.get('address_line_2')?.hasError('required')">
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <button mat-stroked-button type="button" (click)="openPicker(i, branch)">
              {{ "locateOnMap" | translate }}
            </button>
          </div>

          <div class="flex flex-row gap-4 hidden">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput placeholder="Latitude" formControlName="lat" readonly />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" readonly />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="false" class="form-actions mt-4 flex gap-4">
            <button *ngIf="location.length > 1" mat-raised-button color="warn" type="button" (click)="removeBranch(i)">
              {{ "REMOVE" | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" (click)="addBranch()">
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>

          <mat-divider class="my-4"></mat-divider>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6 gap-4">
        <app-secondary-button (click)="stepper.previous()">
          <div>{{ "BACK" | translate }}</div>
        </app-secondary-button>

        <app-primary-button [disabled]="!locationForm.valid" (click)="stepper.next()">
          <div>{{ "NEXT" | translate }}</div>
        </app-primary-button>
      </div>
    </form>
  </mat-step>

  <mat-step clientForm [stepControl]="clientForm">
    <form [formGroup]="clientForm" class="w-full">
      <ng-template matStepLabel>{{ "CLIENT" | translate }}</ng-template>

      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input type="text" matInput [matAutocomplete]="auto" formControlName="client_name" />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onClientSelected($event)">
              <mat-option *ngFor="let client of filteredClients | async"
                [value]="client.client_first_name + ' ' + client.client_last_name">
                {{ client.client_first_name }} {{ client.client_last_name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Client First Name" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="client_first_name" />
            <mat-error *ngIf="clientForm.get('client_first_name')?.hasError('required')">
              {{ "CLIENT_PERSON_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Client Last Name" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="client_last_name" />
            <mat-error *ngIf="clientForm.get('client_last_name')?.hasError('required')">
              {{ "CLIENT_PERSON_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>


        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NUMBER" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_number" />
            <mat-error *ngIf="clientForm.get('contact_number')?.hasError('required')">
              {{ "CLIENT_NUMBER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "Address Line 1" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="line_1" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Address Line 2" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="line_2" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "STATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="state" (selectionChange)="getdistricts()">
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>
              <mat-option *ngFor="let state of allState" [value]="state">{{
                state
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "DISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="district" (selectionChange)="getsubdistricts()">
              <mat-option value="">{{
                "SELECT_DISTRICT" | translate
                }}</mat-option>
              <mat-option *ngFor="let district of allDistricts" [value]="district">{{ district }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('district')?.hasError('required')">
              {{ "DISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "SUBDISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="sub_district" (selectionChange)="getvillages()">
              <mat-option value="">{{
                "SELECT_SUBDISTRICT" | translate
                }}</mat-option>
              <mat-option *ngFor="let subdistrict of allSubDistricts" [value]="subdistrict">{{ subdistrict
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('sub_district')?.hasError('required')">
              {{ "SUBDISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "VILLAGES" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="villages">
              <mat-option value="">{{
                "SELECT_VILLAGE" | translate
                }}</mat-option>
              <mat-option *ngFor="let village of allVillage" [value]="village">{{ village }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('villages')?.hasError('required')">
              {{ "VILLAGES_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6 gap-4">
        <app-secondary-button (click)="stepper.previous()">
          <div>{{ "BACK" | translate }}</div>
        </app-secondary-button>

        <app-primary-button (click)="onSubmit()">
          <div>
            {{
            projectId
            ? ("UPDATE_PROJECT" | translate)
            : ("SAVE_PROJECT" | translate)
            }}
          </div>
        </app-primary-button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>